module.exports = "/legacy/296775163815d3260c449a3c76d78306.svg";